// extracted by mini-css-extract-plugin
export default {"heading":"Vj-z","list":"Wj-z"};